import { Listbox, Transition } from '@headlessui/react';
import { ReactComponent as CheckedIcon } from 'components/icons/icon-checked.svg';
import { ReactComponent as ChevronDownIcon } from 'components/icons/icon-chevron-down.svg';

/**
 *
 * @param {{
 * data:any[],
 * selected: string | undefined,
 * setSelected: React.Dispatch<React.SetStateAction<string>>,
 * selectedColor?:string
 * }} param0
 * @returns
 */
export default function LifeCyclePlaybookListBoxSelector({
  data,
  selected,
  setSelected,
  selectedColor,
}) {
  return (
    <div className="flex items-center justify-center">
      <div className="w-full max-w-xs mx-auto">
        <Listbox
          as="div"
          className="space-y-1"
          value={selected}
          // @ts-ignore
          onChange={setSelected}
        >
          {({ open }) => (
            <>
              <div className="relative -ml-2">
                <span className="inline-block w-full">
                  <Listbox.Button
                    className={`cursor-default relative w-full pl-2 py-0.5 pr-10 rounded-lg text-left focus:outline-none focus:bg-segments-gray focus:bg-opacity-50 hover:bg-segments-gray hover:bg-opacity-50 transition ease-in-out duration-150 sm:text-sm sm:leading-5 ${
                      open && 'bg-segments-gray bg-opacity-50'
                    }`}
                  >
                    <span
                      className={`block truncate text-2xl leading-7 ${selectedColor}`}
                    >
                      {selected}
                    </span>
                    <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                      <ChevronDownIcon />
                    </span>
                  </Listbox.Button>
                </span>

                <Transition
                  show={open}
                  leave="transition ease-in duration-100"
                  leaveFrom="opacity-100"
                  leaveTo="opacity-0"
                  className="absolute min-w-full mt-1 bg-white shadow-lg rounded-2xl"
                >
                  <Listbox.Options
                    static
                    className="overflow-auto leading-6 divide-y rounded-md shadow-xs max-h-60 focus:outline-none sm:text-sm sm:leading-5"
                  >
                    {data?.map((item) => (
                      <Listbox.Option key={item} value={item}>
                        {({ selected, active }) => (
                          <div
                            className={`${
                              active
                                ? 'bg-segments-accent-green-3'
                                : 'text-gray-900'
                            } cursor-default select-none relative py-2.5 pl-8 pr-4 text-base`}
                          >
                            <span
                              className={`${
                                selected ? 'font-semibold' : 'font-normal'
                              } block whitespace-nowrap`}
                            >
                              {item}
                            </span>
                            {selected && (
                              <span
                                className={`${
                                  active ? 'text-black' : 'text-segments-dark'
                                } absolute inset-y-0 left-0 flex items-center pl-1.5`}
                              >
                                <CheckedIcon />
                              </span>
                            )}
                          </div>
                        )}
                      </Listbox.Option>
                    ))}
                  </Listbox.Options>
                </Transition>
              </div>
            </>
          )}
        </Listbox>
      </div>
    </div>
  );
}
